import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ContextService } from './context.service';

import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { QueryDefinitionData, QueryPropertyData, CriteriaData, PagedResult } from '../interfaces/asi.interfaces';
import { ServiceBase } from './service-base';

@Injectable({
  providedIn: 'root'
})
export class IqaService extends ServiceBase {

  constructor(private http: HttpClient, contextService: ContextService) { 
    super(contextService);
    
  }
  public getQueryColumns(queryPath:string):Observable<string[]>{
    let headers = this.getHeaders();
    let url = this.getUrl('QueryDefinition/_execute');
    let findBypath = {
      "$type": "Asi.Soa.Core.DataContracts.GenericExecuteRequest, Asi.Contracts",
      "OperationName": "FindByPath",
      "EntityTypeName": "QueryDefinition",
      "Parameters": {
          "$type": "System.Collections.ObjectModel.Collection`1[[System.Object, mscorlib]], mscorlib",
          "$values": [
              {
                  "$type": "System.String",
                  "$value": queryPath //particular query.
              }
          ]
      },
      "ParameterTypeName": {
          "$type": "System.Collections.ObjectModel.Collection`1[[System.String, mscorlib]], mscorlib",
          "$values": [
              "System.String"
          ]
      },
      "UseJson": false
    }
    return this.http.post(url, findBypath, {headers:headers}).pipe(map((res: QueryDefinitionData) => { 
      
      return res.Result.Properties.$values.map((x: QueryPropertyData) => x.PropertyName) }));

  }

  public getQueryParameters(queryPath: string):Observable<string[]>{
    let headers = this.getHeaders();
    let url = this.getUrl('QueryDefinition/_execute');
    let findBypath = {
      "$type": "Asi.Soa.Core.DataContracts.GenericExecuteRequest, Asi.Contracts",
      "OperationName": "FindByPath",
      "EntityTypeName": "QueryDefinition",
      "Parameters": {
          "$type": "System.Collections.ObjectModel.Collection`1[[System.Object, mscorlib]], mscorlib",
          "$values": [
              {
                  "$type": "System.String",
                  "$value": queryPath //particular query.
              }
          ]
      },
      "ParameterTypeName": {
          "$type": "System.Collections.ObjectModel.Collection`1[[System.String, mscorlib]], mscorlib",
          "$values": [
              "System.String"
          ]
      },
      "UseJson": false
    }
    // console.log("iqa &&&&&&&&&&&&&&&&&&&&&&&&&&&")
    return this.http.post(url, findBypath, {headers:headers}).pipe(map((res: QueryDefinitionData) => { 
      
      return res.Result.Parameters.$values.map((x: CriteriaData) => x.PropertyName) }));
  }

  public getIqaResults(queryPath:string,parameters: Map<string,string>):Observable<PagedResult>{
    const headers = this.getHeaders();
    const params = new HttpParams().set('QueryName',queryPath);
    const url = this.getUrl('iqa');
    parameters.forEach((value:string, key:string)=>{
      params.set('parameter',value);
    });
    return this.http.get(url,{params,headers}).pipe(map((res:PagedResult)=>res)).pipe(catchError(this.handleError));

  }
  
}
